import { Component, OnInit } from '@angular/core';
import { BaseGridFilter } from '@shared/base';

@Component({
  selector: 'gcc-grid-typeahead-filter',
  templateUrl: './grid-typeahead-filter.component.html',
  styleUrls: ['./grid-typeahead-filter.component.scss']
})
export class GridTypeaheadFilterComponent extends BaseGridFilter implements OnInit {
  constructor() {
    super();
  }

  public ngOnInit(): void {}
}
